<template>
  <div class="container mt-2">
    <!-- <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/">{{
            this.$store.getters.getWordLocale("txt_anasayfa")
          }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ this.$store.getters.getWordLocale("txt_talep_listesi") }}
        </li>
      </ol>
    </nav> -->

    <!-- <div class="container seo-section">
      <h1>{{ this.$store.state.leadTitleX }}</h1>
      <h2>{{ this.$store.state.leadDescriptionX }}</h2>
      <h3 v-show="this.$store.state.leadKeywordsX.length > 0">
        {{
          this.$store.state.leadKeywordsX.length > 0
            ? this.$store.state.leadKeywordsX.split(",").join(", ")
            : ""
        }}
      </h3>
    </div> -->
  </div>

  <component
    :leadContent="this.$store.state.domainContentX.LeadContent"
    :is="optionComponent"
  />
</template> 

<script>
import { defineAsyncComponent } from "vue";
const Theme1 = defineAsyncComponent(() =>
  import("../components/theme1/Leads.vue")
);

const Theme2 = defineAsyncComponent(() =>
  import("../components/theme2/Leads.vue")
);

const Theme4 = defineAsyncComponent(() =>
  import("../components/theme4/Leads.vue")
);

const Theme6 = defineAsyncComponent(() =>
  import("../components/theme6/Leads.vue")
);

import PagePropertiesMixin from "../mixins/pagePropertiesMixin";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";
export default {
  mixins: [PagePropertiesMixin],
  props: {
    leadTitle: String,
    leadDescription: String,
    leadKeywords: String,
  },
  setup(props) {
    const siteData = reactive({
      title: props.leadTitle,
      description: props.leadDescription,
      keywords: props.leadKeywords,
    });

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
      ],
    });
  },
  data() {
    return {
      pageTitle: "",
      pageMeta: [],
    };
  },
  components: {},
  computed: {
    optionComponent() {
      if (this.$store.state.modelCodeX == "default") {
        return Theme1;
      }

      if (this.$store.state.modelCodeX == "ek-web") {
        return Theme2;
      }

      if (this.$store.state.modelCodeX == "multi-company") {
        return Theme4;
      }

      if (this.$store.state.modelCodeX == "multi-company-1") {
        return Theme6;
      }

      return "";
    },
  },
  methods: {},
  mounted() {
    // this.pageTitle = "Talep Listesi";
    // this.pageMeta = [
    //   {
    //     name: "description",
    //     content: `Generator Turkey Verified Manufacturers and Turkish Generator Supplier Companies list Turkey`,
    //   },
    //   {
    //     property: "keywords",
    //     content: `Generator, Generator Turkey, Turkish Generator ,  Generator Turkish Companies, Generator in Turkey, Generator Istanbul`,
    //   },
    //   {
    //     property: "site_name",
    //     content: `https://exporters.texpo.net/`,
    //   },
    //   {
    //     property: "url",
    //     content: `https://exporters.texpo.net/`,
    //   },
    // ];
  },
  created() {},
};
</script>

<style>
.seo-section {
  border: 1px solid #ced4da;
  border-radius: 4px;
  color: #202428;
  background-color: #ffffff;
  padding: 8px;
}

.seo-section h1 {
  font-size: 25px;
}

.seo-section h2 {
  font-size: 18px;
}

.seo-section h3 {
  font-size: 14px;
}
</style>